import { Stack } from '@mui/material';

import { Text, api } from 'common';

import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate.tsx';
import { BlockSelectField } from '../../ConfigFields/SelectField.tsx';
import { BlockTextField } from '../../ConfigFields/TextField.tsx';

export function SortBlockFormFields() {
  return (
    <Stack gap={2}>
      <Text variant="heading5" bold>
        Sorting and Limiting
      </Text>
      <BlockValueTemplateField
        fieldName="config.baseFilters.sortConfig.fieldToSort"
        label="Field to sort"
        helperText="The name of a field in each entry in the list to sort by (can be dynamically specified via {{...}} notation); leave blank to remove sorting"
      />
      <BlockSelectField
        fieldName="config.baseFilters.sortConfig.sortDirection"
        label="Sort direction"
        options={Object.values(
          api.FlowDefinition.PatientDataStore.FilterAndSortConfig.SortDirection
        ).map((entry) => ({
          label: entry,
          value: entry,
        }))}
      />
      <BlockTextField
        fieldName="config.baseFilters.limit"
        label="Number of items to to return"
        type="number"
      />
    </Stack>
  );
}
